import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type ReplyFilter = "all" | "unreplied";
export type StarFilter = 1 | 2 | 3 | 4 | 5 | null;

export interface ReviewFilterState {
  starFilter: StarFilter;
  replyFilter: ReplyFilter;
}

const DEFAULT_FILTERS: ReviewFilterState = { starFilter: null, replyFilter: "all" };

interface ReviewUIState {
  isCreateDialogOpen: boolean;
  isEditDialogOpen: boolean;
  editingReviewId: string | null;

  starFilter: StarFilter;
  replyFilter: ReplyFilter;

  openCreateDialog: () => void;
  closeCreateDialog: () => void;
  openEditDialog: (reviewId: string) => void;
  closeEditDialog: () => void;

  setStarFilter: (value: StarFilter) => void;
  setReplyFilter: (value: ReplyFilter) => void;
  setFilters: (value: ReviewFilterState) => void;
  clearFilters: () => void;
}

export const useReviewUIStore = create<ReviewUIState>()(
  devtools(
    (set) => ({
      isCreateDialogOpen: false,
      isEditDialogOpen: false,
      editingReviewId: null,
      ...DEFAULT_FILTERS,

      openCreateDialog: () =>
        set({
          isCreateDialogOpen: true,
          isEditDialogOpen: false,
          editingReviewId: null,
        }),

      closeCreateDialog: () => set({ isCreateDialogOpen: false }),

      openEditDialog: (reviewId) =>
        set({
          isEditDialogOpen: true,
          editingReviewId: reviewId,
          isCreateDialogOpen: false,
        }),

      closeEditDialog: () =>
        set({
          isEditDialogOpen: false,
          editingReviewId: null,
        }),

      setStarFilter: (value) => set({ starFilter: value }),
      setReplyFilter: (value) => set({ replyFilter: value }),
      setFilters: (value) => set(value),
      clearFilters: () => set(DEFAULT_FILTERS),
    }),
    { name: "review-ui-store" }
  )
);
